import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SysGeneriqueDataType } from '../models/models';
import api from './api';

interface SysGeneriqueDataTypeState {
  types: SysGeneriqueDataType[];
  loading: boolean;
  error: string | null;
}

const initialState: SysGeneriqueDataTypeState = {
  types: [],
  loading: false,
  error: null,
};

export const fetchSysGeneriqueDataTypes = createAsyncThunk<
  SysGeneriqueDataType[],
  void,
  { rejectValue: string }
>('sysGeneriqueDataType/fetchAll', async (_, thunkAPI) => {
  try {
    const response = await api.get('/sys_generique_data_type');
    return response.data.data as SysGeneriqueDataType[];
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.error || error.response?.data?.message || 'Failed to fetch types.');
  }
});

const sysGeneriqueDataTypeSlice = createSlice({
  name: 'sysGeneriqueDataType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSysGeneriqueDataTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSysGeneriqueDataTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.types = action.payload;
      })
      .addCase(fetchSysGeneriqueDataTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Unknown error';
      });
  },
});

export default sysGeneriqueDataTypeSlice.reducer;
